interface FormattedTitle {
  sanitizedTitle: string
  className: string
}

/**
 * Formats a raw menu title by sanitizing it and determining its associated CSS class name.
 *
 * @param rawTitle - The raw title string to be formatted. It is expected to start and end with the same special character
 * (`!`, `/`, or `|`) to determine its formatting style.
 * @returns An object containing:
 * - `sanitizedTitle`: The title string with the surrounding special characters removed.
 * - `className`: The CSS class name corresponding to the formatting style.
 */
export const formatMenuTitle = (rawTitle: string): FormattedTitle => {
  const sanitizedTitle = rawTitle.replace(/^([!/|])(.*)\1$/, '$2')
  let className = ''

  if (rawTitle.startsWith('!') && rawTitle.endsWith('!')) {
    className = 'italic-blue'
  } else if (rawTitle.startsWith('/') && rawTitle.endsWith('/')) {
    className = 'italic'
  } else if (rawTitle.startsWith('|') && rawTitle.endsWith('|')) {
    className = 'boxed'
  }

  return { sanitizedTitle, className }
}
